// extracted by mini-css-extract-plugin
export default {"itemResult":"styles_itemResult__XSXaM"};